<template>
    <Transition mode="out-in">
        <template v-if="!loaded">
            <span style="cursor: wait;" role="status" aria-label="Loading favorites">
                <i class="fa fa-fw fa-star text-muted" style="opacity: 0.3;" aria-hidden="true"></i>
            </span>
        </template>
        <template v-else-if="isFavorite(boardId)">
            <span @click="toggleFavorite(boardId)" v-tooltip="'Remove from Favorites'" class="favorite-star"
                role="button" :aria-label="`Remove board ${boardId} from favorites`" aria-pressed="true" tabindex="0"
                @keydown.enter="toggleFavorite(boardId)" @keydown.space.prevent="toggleFavorite(boardId)">
                <i class="fa fa-fw fa-star text-warning" aria-hidden="true"></i>
            </span>
        </template>
        <template v-else>
            <span @click="toggleFavorite(boardId)" v-tooltip="'Add to Favorites'" class="favorite-star" role="button"
                :aria-label="`Add board ${boardId} to favorites`" aria-pressed="false" tabindex="0"
                @keydown.enter="toggleFavorite(boardId)" @keydown.space.prevent="toggleFavorite(boardId)">
                <i class="fa fa-fw fa-star text-white" aria-hidden="true"></i>
            </span>
        </template>
    </Transition>
</template>

<style scoped>
.favorite-star {
    cursor: pointer;
}

.favorite-star i {
    transition: filter 0.2s;
}

.favorite-star:hover i {
    filter: brightness(1.3) drop-shadow(0 0 3px #ffe066);
}
</style>

<script>
import axios from 'axios';
import _ from 'lodash';
import Swal from 'sweetalert2';

export default {
    props: {
        boardId: {
            type: Number,
            required: true,
        },
    },
    emits: [
    ],
    data() {
        return {
            favorites: [],
            loaded: false,
        };
    },
    mounted() {
        console.log("Component mounted.");

        this.load();
    },
    beforeUnmount() {
        console.log("Component before unmount.");
    },
    unmounted() {
        console.log("Component unmounted.");
    },
    methods: {
        load() {
            console.log("Loading favorites...");
            const api_url = `/api/v1/favorite_boards/me`;
            axios.get(api_url)
                .then((response) => {
                    console.log("Favorites loaded:", response.data);
                    this.favorites = response.data.data;
                    this.loaded = true;
                })
                .catch((error) => {
                    console.error("Error loading favorites:", error);
                });
        },

        isFavorite: function (id) {
            //Check if board is in favorites
            return this.favorites.includes(id);
        },

        toggleFavorite: function (id) {
            //Add to favorites
            console.log('toggleFavorite', id);

            //Check if already in favorites
            if (this.favorites.some(favorite => favorite === id)) {
                //Already in favorites, delete
                console.log('Already in favorites. Removing...');

                //Remove from favorites for instant user feedback
                _.remove(this.favorites, (favorite) => favorite === id);

                axios.delete(`/api/v1/favorite_boards/${id}`)
                    .then((response) => {
                        console.log(response);

                        window.$toast.add({
                            severity: 'success',
                            summary: 'Removed from favorites',
                            html: '<a class="btn btn-danger mt-1" href="/favorites/me">My Favorites</a>',
                            life: 4000
                        });
                    })
                    .catch((error) => {
                        console.error(error);
                        console.log('Showing error toast...')
                        Swal.fire({
                            title: 'Problem',
                            text: 'There was a problem with your favorites. Please try again.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            theme: 'auto'
                        });

                        //Add back to favorites
                        this.favorites.push(id);
                    });

                return true;
            }

            //Otherwise, continue adding
            console.log('Adding to favorites...');

            //Add to end of favorites for instant user feedback
            this.favorites.push(id);

            axios.put(`/api/v1/favorite_boards/${id}`)
                .then((response) => {
                    console.log(response);
                    console.log('Showing toast...')

                    window.$toast.add({
                        severity: 'success',
                        summary: 'Added to favorites',
                        html: '<a class="btn btn-danger mt-1" href="/favorites/me">My Favorites</a>',
                        life: 4000
                    });
                })
                .catch((error) => {
                    console.error(error);
                    console.log('Showing error toast...')

                    Swal.fire({
                        title: 'Problem',
                        text: 'There was a problem with your favorites. Please try again.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        theme: 'auto'
                    });

                    //Remove from favorites
                    _.remove(this.favorites, (favorite) => favorite === id);
                });
        },
    },
    watch: {
    },
};
</script>